module.exports = __webpack_public_path__ + "img/food_sushi.2d11d924.png";